import { AlertButton } from '@shared/alert/alertButton';
import { UserModel } from '@user/model/user.model';
import { ProjectModel } from '../model/project.model';
import { AlertHelper } from '@shared/alert/alert.helper';
import { Injectable } from '@angular/core';
import { ProjectNavigationPresenter } from '@project-navigation/project-navigation.presenter';

@Injectable({ providedIn: 'root' })
export class CheckSaveProjectService {
  constructor(
    private userModel: UserModel,
    private projectModel: ProjectModel,
    private alertHelper: AlertHelper,
    private projectNavigationPresenter: ProjectNavigationPresenter
  ) {}

  public async checkSaveProjectOrAbort(): Promise<boolean> {
    if (this.projectModel.currentProjectRequiresSaving) {
      if (
        this.userModel.userProfile &&
        this.userModel.userProfile.isRegisteredUserAccount() &&
        this.userModel.user &&
        this.userModel.user.hasPermission("SAVE_PROJECTS")
      ) {
        const answer = await this.alertHelper
          .showAlert(
            'main.title.confirm_create_new_project_with_save_option',
            'main.message.confirm_create_new_project_with_save_option',
            {},
            [AlertButton.YES, AlertButton.NO, AlertButton.CANCEL],
            "help"
          );

        if (answer === AlertButton.YES) {
          await this.projectNavigationPresenter.openSaveProjectDialog();
          return !this.projectModel.currentProjectRequiresSaving;
        } else {
          return answer === AlertButton.NO;
        }
      } else {
        const answer = await this.alertHelper
          .showAlert(
            'main.title.confirm_create_new_project',
            'main.message.confirm_create_new_project',
            {},
            [AlertButton.OK, AlertButton.CANCEL],
            "help"
          );

        return answer === AlertButton.OK;
      }
    } else {
      return true;
    }
  }
}
